export interface UnansweredField {
  label: string;
  anchorId: string;
}

interface TopLevelField extends UnansweredField {
  key: string;
}

export const TOP_LEVEL_FIELDS: TopLevelField[] = [
  { key: 'diagnosedConditions', label: 'Tidigare diagnos', anchorId: 'q-2' },
  {
    key: 'hasMultipleHeadaches',
    label: 'Flera typer av huvudvärk',
    anchorId: 'q-3',
  },
  {
    key: 'ageFirstAttack',
    label: 'Ålder vid första attacken',
    anchorId: 'q-4',
  },
  {
    key: 'headacheDuration',
    label: 'Hur länge varar attackerna',
    anchorId: 'q-5',
  },
  { key: 'painLocation', label: 'Var sitter smärtan', anchorId: 'q-6' },
  { key: 'attackPattern', label: 'Attackmönster', anchorId: 'q-7' },
  { key: 'painCharacter', label: 'Smärtkaraktär', anchorId: 'q-8' },
  { key: 'painIntensity', label: 'Smärtintensitet', anchorId: 'q-9' },
  {
    key: 'physicalActivityEffect',
    label: 'Fysisk aktivitet',
    anchorId: 'q-10',
  },
  {
    key: 'preferredActionDuringAttack',
    label: 'Vad gör du under attack',
    anchorId: 'q-11',
  },
  { key: 'associatedSymptoms', label: 'Associerade symptom', anchorId: 'q-12' },
  { key: 'auraSymptoms', label: 'Aura', anchorId: 'q-13' },
  { key: 'headacheFrequency', label: 'Anfallsfrekvens', anchorId: 'q-16' },
  {
    key: 'frequencyDuration',
    label: 'Hur länge med denna frekvens',
    anchorId: 'q-17',
  },
  {
    key: 'initialFrequency',
    label: 'Initial anfallsfrekvens',
    anchorId: 'q-18',
  },
  { key: 'worseningOverTime', label: 'Försämring över tid', anchorId: 'q-19' },
  { key: 'triggers', label: 'Utlösande faktorer', anchorId: 'q-20' },
  { key: 'headacheFreeDays', label: 'Huvudvärksfria dagar', anchorId: 'q-21' },
  { key: 'comorbidities', label: 'Samsjuklighet', anchorId: 'q-22' },
  {
    key: 'nonMedicationTreatments',
    label: 'Icke-medikamentella behandlingar',
    anchorId: 'q-23',
  },
  {
    key: 'medicationOveruse',
    label: 'Överkonsumtion av läkemedel',
    anchorId: 'q-24',
  },
  { key: 'hasWithdrawal', label: 'Läkemedelsavgiftning', anchorId: 'q-25' },
  { key: 'radiologyExam', label: 'Skiktröntgen (CT)', anchorId: 'q-26' },
  { key: 'controllMrt', label: 'Magnetkamera (MRT)', anchorId: 'q-27' },
  { key: 'takesPainMedication', label: 'Anfallsmedicin', anchorId: 'q-28' },
  { key: 'heredityMigraine', label: 'Ärftlighet migrän', anchorId: 'q-29' },
  {
    key: 'neurologicalFamilyDiseases',
    label: 'Neurologisk sjukdom i släkten',
    anchorId: 'q-30',
  },
  { key: 'otherConditions', label: 'Andra sjukdomar', anchorId: 'q-31' },
  { key: 'hypertension', label: 'Hypertoni', anchorId: 'q-32' },
  {
    key: 'bloodPressureLastYear',
    label: 'Blodtryck senaste året',
    anchorId: 'q-33',
  },
  { key: 'weight', label: 'Vikt och längd', anchorId: 'q-34' },
  { key: 'biologicalSex', label: 'Biologiskt kön', anchorId: 'q-35' },
  { key: 'additionalInfo', label: 'Övrigt att tillägga', anchorId: 'q-37' },
];

export const FOLLOW_UP_TOP_LEVEL_FIELDS: TopLevelField[] = [
  {
    key: 'headacheLogged',
    label: 'Huvudvärksdagbok',
    anchorId: 'q-headacheLogged',
  },
  {
    key: 'headacheAssessment',
    label: 'Huvudvärk sedan förra besöket',
    anchorId: 'q-headacheAssessment',
  },
  {
    key: 'daysAssessment',
    label: 'Antal huvudvärksdagar',
    anchorId: 'q-daysAssessment',
  },
  {
    key: 'painIntensityChange',
    label: 'Smärtintensitet',
    anchorId: 'q-painIntensityChange',
  },
  {
    key: 'attackDurationChange',
    label: 'Anfallens längd',
    anchorId: 'q-attackDurationChange',
  },
  {
    key: 'hasSideEffects',
    label: 'Biverkningar',
    anchorId: 'q-hasSideEffects',
  },
  {
    key: 'stoppedMedication',
    label: 'Avslutad medicin',
    anchorId: 'q-stoppedMedication',
  },
  {
    key: 'hasStartedNewMedication',
    label: 'Ny medicin',
    anchorId: 'q-hasStartedNewMedication',
  },
  {
    key: 'hasNewCondition',
    label: 'Ny sjukdom eller medicinsk händelse',
    anchorId: 'q-hasNewCondition',
  },
  {
    key: 'hasOtherImportantInfo',
    label: 'Annat av vikt',
    anchorId: 'q-hasOtherImportantInfo',
  },
  {
    key: 'midasWorkDays',
    label: 'Frånvaro från arbete eller skola',
    anchorId: 'q-midasWorkDays',
  },
  {
    key: 'midasReducedWorkDays',
    label: 'Halverad kapacitet i arbete eller skola',
    anchorId: 'q-midasReducedWorkDays',
  },
  {
    key: 'midasHouseholdMissed',
    label: 'Uteblivet hushållsarbete',
    anchorId: 'q-midasHouseholdMissed',
  },
  {
    key: 'midasHouseholdReduced',
    label: 'Halverad kapacitet i hushållsarbete',
    anchorId: 'q-midasHouseholdReduced',
  },
  {
    key: 'midasSocialMissed',
    label: 'Avstått från familj och fritid',
    anchorId: 'q-midasSocialMissed',
  },
  {
    key: 'estimatedHeadacheDaysLast3Months',
    label: 'Huvudvärksdagar senaste 3 månaderna',
    anchorId: 'q-estimatedHeadacheDaysLast3Months',
  },
  {
    key: 'midasPainSeverity',
    label: 'Genomsnittlig smärta (0–10)',
    anchorId: 'q-midasPainSeverity',
  },
  {
    key: 'hitPainIntensity',
    label: 'Hur ofta smärtan är svår',
    anchorId: 'q-hitPainIntensity',
  },
  {
    key: 'hitActivityLimitation',
    label: 'Begränsning i vardagen',
    anchorId: 'q-hitActivityLimitation',
  },
  {
    key: 'hitDesireToLieDown',
    label: 'Behov av att ligga ner',
    anchorId: 'q-hitDesireToLieDown',
  },
  {
    key: 'hitFatigueFromHeadache',
    label: 'Trötthet',
    anchorId: 'q-hitFatigueFromHeadache',
  },
  {
    key: 'hitIrritabilityFromHeadache',
    label: 'Irritation',
    anchorId: 'q-hitIrritabilityFromHeadache',
  },
  {
    key: 'hitConcentrationLimitation',
    label: 'Koncentration',
    anchorId: 'q-hitConcentrationLimitation',
  },
  {
    key: 'bloodPressureInstruction',
    label: 'Blodtrycksmätning',
    anchorId: 'q-bloodPressureInstruction',
  },
  {
    key: 'needsPrescriptionRenewal',
    label: 'Receptförnyelse',
    anchorId: 'q-needsPrescriptionRenewal',
  },
];

// false and 0 are real answers (Nej, zero MIDAS days), so only absent or blank values count
function isEmpty(value: unknown): boolean {
  if (value === undefined || value === null) return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'string') return value.trim() === '';
  return false;
}

export function getUnansweredFields(
  fields: Record<string, unknown>,
  topLevelFields: TopLevelField[] = TOP_LEVEL_FIELDS
): {
  count: number;
  total: number;
  unanswered: UnansweredField[];
} {
  const unanswered: UnansweredField[] = [];

  for (const { key, label, anchorId } of topLevelFields) {
    if (isEmpty(fields[key])) {
      unanswered.push({ label, anchorId });
    }
  }

  return {
    count: unanswered.length,
    total: topLevelFields.length,
    unanswered,
  };
}
